import { useState } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { COLOR_MAP } from "../../../../constants/ColorNames";
import { INFO_ICON } from "../../../../constants/icons/InfoIcon";
import CLOSE_ICON from "../../../../constants/icons/CloseIcon";

export default function InfoBridge() {
    const [isInfoBridge, setIsInfoBridge] = useState(true);

    return (
        isInfoBridge ? (
            <Box
                display='flex'
                alignItems='center'
                bgcolor={COLOR_MAP.WARNING_BOLD}
                p='12px'
                borderRadius='8px'
                color={COLOR_MAP.WHITE}
                columnGap='8px'
                m='-20px -20px -30px'
                zIndex={999}
                sx={{
                  position: "sticky",
                  bottom: "3.2rem",
                  left: "3.2rem"
                }}
            >
                <INFO_ICON width={24} height={24} fill={COLOR_MAP.WHITE} />
                <Box flex={1}>
                    <Typography fontSize='1.4rem' lineHeight='2rem'>
                        Adding each Follow-up will consume 1 outreach credit.
                    </Typography>
                </Box>
                <Box onClick={() => setIsInfoBridge(false)} sx={{ cursor: 'pointer' }}>
                    <CLOSE_ICON />
                </Box>
            </Box>
        ) : null
    );
}
